import { render, staticRenderFns } from "./zzzs.vue?vue&type=template&id=a728e318&scoped=true&"
import script from "./zzzs.vue?vue&type=script&lang=js&"
export * from "./zzzs.vue?vue&type=script&lang=js&"
import style0 from "./zzzs.vue?vue&type=style&index=0&id=a728e318&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a728e318",
  null
  
)

export default component.exports